import {
  AggregateMap as GlobalAggregateMap,
  AggregateReduce as GlobalAggregateReduce,
} from './common.js';

export const ImageClozeAssociationSelectionsReducer = () => [];

export const ImageClozeAssociationSelectionsAggregator = () => [];

export default {
  AggregateMap: GlobalAggregateMap(ImageClozeAssociationSelectionsAggregator),
  AggregateReduce: GlobalAggregateReduce(
    ImageClozeAssociationSelectionsReducer
  ),
};
